module.exports = __webpack_public_path__ + "img/MERCURY RACING.e3c9a0a.jpg";